import type {MapMouseEvent} from "@vis.gl/react-google-maps";
import {useState} from "react";
import type {LatLng} from "../utils/types";

export function useContextMenu() {
    const [menuPosition, setMenuPosition] = useState<{x: number; y: number}>({x: 0, y: 0});
    const [isMenuVisible, setMenuVisible] = useState(false);
    const [contextMenuCoordinates, setContextMenuCoordinates] = useState<LatLng>({
        lat: 0,
        lng: 0,
    });

    const handleMapContextMenu = (event: MapMouseEvent) => {
        if (event.domEvent && event.detail.latLng) {
            const {clientX, clientY} = event.domEvent as MouseEvent;
            const {lat, lng} = event.detail.latLng;

            if (typeof lat === "number" && typeof lng === "number") {
                setMenuPosition({x: clientX, y: clientY});
                setMenuVisible(true);
                setContextMenuCoordinates({lat, lng});
            }
        }
    };

    const hideMenu = () => setMenuVisible(false);

    return {
        menuPosition,
        isMenuVisible,
        contextMenuCoordinates,
        handleMapContextMenu,
        hideMenu,
    };
}
